import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { LANDING } from "@/constants/testIds";

const promotions = [
  {
    title: "Wear Spurs Gear · 10% Off",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/isvsjfzn_ChatGPT%20Image%20Jun%201%2C%202026%2C%2003_41_41%20PM.png",
    tag: "Offer",
  },
  {
    title: "Game Day Specials",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/6wm4k6fv_ChatGPT%20Image%20Jun%201%2C%202026%2C%2003_40_03%20PM.png",
    tag: "Menu",
  },
  {
    title: "Official Spurs Finals Watch Party",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/o17hpxkh_ChatGPT%20Image%20Jun%201%2C%202026%2C%2003_38_13%20PM.png",
    tag: "Event",
  },
];

const ads = [
  {
    title: "Fade City Barbershop",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/bg5a4kp1_ChatGPT%20Image%20Jun%201%2C%202026%2C%2004_18_16%20PM.png",
    tag: "Facebook Ad",
  },
  {
    title: "Bright Home Services",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/lo60rn8j_ChatGPT%20Image%20Jun%201%2C%202026%2C%2004_09_47%20PM.png",
    tag: "Facebook Ad",
  },
  {
    title: "La Fiesta Retargeting",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/cc1cst4v_ChatGPT%20Image%20Jun%201%2C%202026%2C%2004_09_41%20PM.png",
    tag: "Retargeting",
  },
];

const websites = [
  {
    title: "La Fiesta Taqueria",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/fgsgolbk_ChatGPT%20Image%20Jun%201%2C%202026%2C%2003_43_07%20PM.png",
    tag: "Restaurant",
  },
  {
    title: "Alamo Auto Repair",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/jc5r2jlu_ChatGPT%20Image%20Jun%201%2C%202026%2C%2003_46_51%20PM.png",
    tag: "Auto Service",
  },
  {
    title: "Elevate Sales Solutions",
    img: "https://customer-assets.emergentagent.com/job_sa-spurs-package/artifacts/vl8vs9aw_ChatGPT%20Image%20Jun%201%2C%202026%2C%2003_49_25%20PM.png",
    tag: "B2B Services",
  },
];

const Card = ({ item, aspect = "aspect-[4/3]", fit = "cover" }) => (
  <div className="group relative rounded-3xl overflow-hidden border border-black/5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] bg-white transition-all hover:-translate-y-1 hover:shadow-[0_20px_50px_rgb(0,0,0,0.08)]">
    <div className={`${aspect} overflow-hidden bg-zinc-50 flex items-center justify-center`}>
      <img
        src={item.img}
        alt={item.title}
        className={`w-full h-full ${fit === "contain" ? "object-contain" : "object-cover"} transition-transform duration-500 group-hover:scale-105`}
      />
    </div>
    <div className="p-5 flex items-center justify-between">
      <h4 className="font-bold tracking-tight text-base md:text-lg">{item.title}</h4>
      <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-zinc-500">
        {item.tag}
      </span>
    </div>
  </div>
);

const Grid = ({ items, aspect, fit }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 mt-8">
    {items.map((it, i) => (
      <Card item={it} key={i} aspect={aspect} fit={fit} />
    ))}
  </div>
);

const Portfolio = () => {
  return (
    <section
      data-testid={LANDING.portfolioSection}
      className="py-24 md:py-32 px-6 md:px-12 bg-[#FAFAFA] border-y border-black/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#EF426F] mb-4">
            Portfolio
          </p>
          <h2 className="text-4xl md:text-6xl font-black tracking-tighter leading-[0.95]">
            See what's{" "}
            <span className="bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-transparent bg-clip-text">
              possible
            </span>
            .
          </h2>
          <p className="mt-5 text-base md:text-lg text-zinc-500">
            A peek at the websites, ads, and promotions we've built for local
            businesses ready to win.
          </p>
        </div>

        <Tabs defaultValue="promotions" className="w-full">
          <div className="flex justify-center">
            <TabsList className="bg-white border border-black/10 rounded-full p-1.5 h-auto">
              <TabsTrigger
                value="promotions"
                data-testid={LANDING.portfolioTabPromotions}
                className="rounded-full px-5 py-2 text-sm font-bold uppercase tracking-wider data-[state=active]:bg-[#0A0A0A] data-[state=active]:text-white"
              >
                Promotions
              </TabsTrigger>
              <TabsTrigger
                value="ads"
                data-testid={LANDING.portfolioTabAds}
                className="rounded-full px-5 py-2 text-sm font-bold uppercase tracking-wider data-[state=active]:bg-[#0A0A0A] data-[state=active]:text-white"
              >
                Ads
              </TabsTrigger>
              <TabsTrigger
                value="websites"
                data-testid={LANDING.portfolioTabWebsites}
                className="rounded-full px-5 py-2 text-sm font-bold uppercase tracking-wider data-[state=active]:bg-[#0A0A0A] data-[state=active]:text-white"
              >
                Websites
              </TabsTrigger>
            </TabsList>
          </div>
          <TabsContent value="promotions">
            <Grid items={promotions} aspect="aspect-square" />
          </TabsContent>
          <TabsContent value="ads">
            <Grid items={ads} aspect="aspect-square" fit="contain" />
          </TabsContent>
          <TabsContent value="websites">
            <Grid items={websites} aspect="aspect-square" fit="contain" />
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default Portfolio;
